import { FC } from "react";
import MainNav from "./MainNav";

export interface HeaderProps {
  navType?: "MainNav1" | "MainNav2";
  className?: string;
}

const Header: FC<HeaderProps> = ({ navType = "MainNav1", className = "" }) => {
  const renderNav = () => {
    switch (navType) {
      case "MainNav1":
        return <MainNav />;
      default:
        return <MainNav />;
    }
  };

  return (
    <div
      className={`nc-Header sticky top-0 w-full left-0 right-0 z-10 ${className}`}
    >
      {renderNav()}
    </div>
  );
};

export default Header;
